module.exports = __webpack_public_path__ + "lang/hu.json";


//////////////////
// WEBPACK FOOTER
// ./lang/hu.json
// module id = 116
// module chunks = 3